import { memo } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'translations';

interface LoginButtonProps {
  onClick: (...args: any[]) => any;
  style?: Record<string, any>;
}

const LoginButton = memo(({ onClick, style = {} }: LoginButtonProps) => {
  const { tC } = useTranslation('features', 'authentication');

  return (
    <Button onClick={onClick} type="primary" style={style}>
      {tC('loginButton')}
    </Button>
  );
});

LoginButton.displayName = 'LoginButton';

export default LoginButton;
